import { MaintenanceAlert } from "components/common";
import { SearchWithFilter } from "components/search";

const TekstligeResultatverdierPage = () => {
  return (
    <>
      <MaintenanceAlert />
      <SearchWithFilter />
    </>
  );
};

export default TekstligeResultatverdierPage;
